<script setup lang="ts">
const { isHomeAsSportbookEnabled } = useFeatureFlagsNew();
</script>

<template>
  <PagesHome v-if="isHomeAsSportbookEnabled" />

  <CasinoGames v-else>
    <template #banners />
    <template #filters />
  </CasinoGames>
</template>
